// Vue
import Vue from 'vue'
import i18n from './i18n'
import App from './App'
// 核心插件
import d2Admin from '@/plugin/d2admin'
// store
import store from '@/store/index'

// [ 可选组件 ]D2-Crud
import D2Crud from '@d2-projects/d2-crud'
// [ 可选组件 ] 图表
import VCharts from 'v-charts'
// [ 可选组件 ] 右键菜单
import contentmenu from 'v-contextmenu'
import 'v-contextmenu/dist/index.css'
// [ 可选组件 ] JSON 树状视图
import vueJsonTreeView from 'vue-json-tree-view'
// [ 可选组件 ] 网格布局
import { GridLayout, GridItem } from 'vue-grid-layout'
// [ 可选组件 ] 区域划分
import SplitPane from 'vue-splitpane'
// [ 可选插件 ] 数据导入导出
import pluginExport from '@d2-projects/vue-table-export'
import pluginImport from '@d2-projects/vue-table-import'
// 菜单和路由设置
import router from './router'
// import { menuHeader, menuAside } from '@/menu'
import { frameInRoutes } from '@/router/routes'
// 全局过滤器
import * as filters from './filters' // global filters
/** 常用flex组件 */
import { Flexbox, FlexboxItem } from '@/components/flexbox'
/** vxe */
import 'xe-utils'
import VXETable from 'vxe-table'
import VXETablePluginExportXLSX from 'vxe-table-plugin-export-xlsx'
VXETable.use(VXETablePluginExportXLSX)
import 'vxe-table/lib/index.css'
// 省市联动
import VueAreaLinkage from 'vue-area-linkage'

// ...
import VXETablePluginElement from 'vxe-table-plugin-element'
import 'vxe-table-plugin-element/dist/style.css'
// ...

import * as myMath from '@/utils/myMath'
import * as tableMerge from '@/utils/tableMerge'

// 自定义全局点击空白处组件
import clickoutside from './directives'
import empty from './directives/empty'
import nodeWrap from '@/components/Flowable/nodeWrap'
import addNode from '@/components/Flowable/addNode'
import func from './plugins/preload.js'
import TreeTable from 'vue-table-with-tree-grid'
Vue.component('tree-table', TreeTable)
import vueEsign from 'vue-esign'
// constants
import Constants from './libs/constants.js'
Vue.prototype.CONSTANTS = Constants
Vue.prototype.$func = func
Vue.use(nodeWrap)
Vue.component('nodeWrap', nodeWrap)
Vue.use(addNode)
Vue.component('addNode', addNode)
Vue.use(VXETable)
VXETable.setup({
  validFullData: 'obsolete' // 将默认为校验全量数据
})

Vue.use(VueAreaLinkage) // 核心插件
Vue.use(d2Admin)


import { getLabelByValue} from "@/utils/index";
//根据list的value取对应的label展示
Vue.prototype.getLabelByValue = getLabelByValue


// 可选插件组件
Vue.use(vueEsign)
Vue.use(D2Crud)
Vue.use(VCharts)
Vue.use(contentmenu)
Vue.use(vueJsonTreeView)
Vue.use(pluginExport)
Vue.use(pluginImport)
Vue.component('d2-grid-layout', GridLayout)
Vue.component('d2-grid-item', GridItem)
Vue.component('SplitPane', SplitPane)
Vue.component('flexbox', Flexbox)
Vue.component('flexbox-item', FlexboxItem)

VXETable.use(VXETablePluginElement)
Vue.directive('enterNumber', {
  bind: function(el, { value = 2 }) {
    el = el.nodeName == 'INPUT' ? el : el.children[0]
    var RegStr = value == 0 ? `^[\\+\\-]?\\d+\\d{0,0}` : `^[\\+\\-]?\\d+\\.?\\d{0,${value}}`
    el.addEventListener('keyup', function() {
      el.value = el.value.match(new RegExp(RegStr, 'g'))
      el.dispatchEvent(new Event('input'))
    })
  }
})
Vue.directive('focus', {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function(el) {
    el.focus()
  }
})
// v-has
Vue.directive('has', {
  bind: function (el, binding) {
    if (!Vue.prototype.$has(binding.value)) {
      el.parentNode
        ? el.parentNode.removeChild(el)
        : (el.style.display = 'none')
    }
  }
})
Vue.directive('clickoutside', clickoutside)
Vue.use(empty)

// register global utility filters. 注册全局过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Object.keys(myMath).forEach(key => {
  Vue.prototype["$" + key] = myMath[key]
})

Object.keys(tableMerge).forEach(key => {
  Vue.prototype["$" + key] = tableMerge[key]
})

import { digit2CNchar } from "./utils/index"
Vue.prototype['$digit2CNchar'] = digit2CNchar


//日期格式化
Date.prototype.format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份 
    "d+": this.getDate(), //日 
    "h+": this.getHours(), //小时 
    "m+": this.getMinutes(), //分 
    "s+": this.getSeconds(), //秒 
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度 
    "S": this.getMilliseconds() //毫秒 
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    }
  }
  return fmt;
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  created() {
    // 处理路由 得到每一级的路由设置
    this.$store.commit('d2admin/page/init', frameInRoutes)
    // 设置顶栏菜单
    // this.$store.commit('d2admin/menu/headerSet', menuHeader)
    // // 初始化菜单搜索功能
    // this.$store.commit('d2admin/search/init', menuHeader)
  },
  mounted() {
    // 展示系统信息
    // this.$store.commit('d2admin/releases/versionShow')
    // 用户登录后从数据库加载一系列的设置
    this.$store.dispatch('d2admin/account/load')
    // 获取并记录用户 UA
    this.$store.commit('d2admin/ua/get')
    // 初始化全屏监听
    this.$store.dispatch('d2admin/fullscreen/listen')
  },
  watch: {
    // 检测路由变化切换侧边栏内容
    '$route.matched': {
      handler(matched) {
        if (matched.length > 0) {
          // const _side = menuAside.filter(menu => menu.path === matched[0].path)
          // this.$store.commit('d2admin/menu/asideSet', _side.length > 0 ? _side[0].children : [])
        }
      },
      immediate: true
    }
  }
}).$mount('#app')
